module.exports = __webpack_public_path__ + "static/media/mindmaster.d2520fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/mindmaster.png
// module id = 1314
// module chunks = 0